import IMask from 'imask';
import { parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js';

export class PhoneInput {
    constructor(inputElement, options = {}) {
        this.input = inputElement;
        this.options = {
            defaultCountry: 'KZ',
            ...options
        };
        
        this.setupInput();
        this.setupMask();
        this.setupValidation();
    }

    setupInput() {
        // Add necessary classes and attributes
        this.input.classList.add('phone-input');
        this.input.setAttribute('type', 'tel');
        this.input.setAttribute('autocomplete', 'tel');
        
        // Create wrapper
        const wrapper = document.createElement('div');
        wrapper.classList.add('phone-input-wrapper', 'relative', 'flex', 'items-center');
        this.input.parentNode.insertBefore(wrapper, this.input);

        // Add validation indicator
        this.validationIcon = document.createElement('div');
        this.validationIcon.classList.add(
            'validation-icon',
            'flex',
            'items-center',
            'ml-1',
            'hidden'
        );
        
        // Move input to wrapper
        wrapper.appendChild(this.input);
        wrapper.appendChild(this.validationIcon);
    }

    setupMask() {
        // Create mask pattern for Kazakhstan phone numbers
        this.mask = IMask(this.input, {
            mask: '7 (700) 000 0000',
            lazy: false,
            placeholderChar: '_',
            definitions: {
                '7': /[7]/,
                '0': /[0-9]/
            },
            prepare: (str) => {
                // Ensure the first digit is always 7
                if (str === '7') return '7';
                return str;
            }
        });

        // Update validation on input
        this.mask.on('accept', () => {
            this.validatePhone();
        });
    }

    setupValidation() {
        this.input.addEventListener('blur', () => {
            this.validatePhone();
        });

        // Add paste event handler
        this.input.addEventListener('paste', (e) => {
            e.preventDefault();
            const pastedText = (e.clipboardData || window.clipboardData).getData('text');
            const cleanNumber = this.cleanPhoneNumber(pastedText);
            this.mask.value = cleanNumber;
        });
    }

    validatePhone() {
        const phoneNumber = this.mask.value.replace(/[^\d]/g, '');
        let isValid = false;

        try {
            isValid = isValidPhoneNumber(phoneNumber, 'KZ');
        } catch (e) {
            isValid = false;
        }

        this.updateValidationUI(isValid);
        return isValid;
    }

    updateValidationUI(isValid) {
        if (!isValid || this.mask.value === '') {
            this.validationIcon.classList.add('hidden');
            return;
        }
        
        // Show small checkmark for valid numbers
        this.validationIcon.classList.remove('hidden');
        this.validationIcon.innerHTML = '<svg class="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>';
    }

    cleanPhoneNumber(number) {
        try {
            const parsed = parsePhoneNumber(number, 'KZ');
            const formatted = parsed.format('NATIONAL').replace('+', '');
            return formatted;
        } catch (e) {
            // If parsing fails, just remove non-digit characters
            return number.replace(/[^\d]/g, '');
        }
    }

    getValue() {
        return this.mask.value.replace(/[^\d]/g, '');
    }

    setValue(value) {
        this.mask.value = value;
        this.validatePhone();
    }

    destroy() {
        this.mask.destroy();
        // Remove the wrapper structure we created
        const wrapper = this.input.closest('.phone-input-wrapper');
        if (wrapper && wrapper.parentNode) {
            wrapper.parentNode.insertBefore(this.input, wrapper);
            wrapper.remove();
        }
    }
}
